/** Règles du chifoumi — PUR. */
import type { RoundOutcome } from '../game/protocol';
import type { Throw } from './gesture';

/** Geste joué : `none` si aucune main lisible au « MI ». */
export type Played = Throw | 'none';

const BEATS: Record<Throw, Throw> = { rock: 'scissors', scissors: 'paper', paper: 'rock' };

export function beats(a: Throw, b: Throw): boolean {
  return BEATS[a] === b;
}

/** Issue d'un coup vu par l'hôte. Pas de geste lisible : perdu (sauf si l'autre non plus). */
export function throwOutcome(
  host: Played,
  guest: Played,
): Extract<RoundOutcome, 'hostLost' | 'guestLost' | 'tie'> {
  if (host === guest) return 'tie';
  if (host === 'none') return 'hostLost';
  if (guest === 'none') return 'guestLost';
  return beats(host, guest) ? 'guestLost' : 'hostLost';
}

export const THROW_EMOJI: Record<Played, string> = {
  rock: '✊',
  paper: '✋',
  scissors: '✌️',
  none: '❔',
};
